<div class="flex flex-col items-start gap-1 text-surface-800 bg-surface-100 dark:text-surface-0 dark:bg-surface-800 rounded-2xl">
    <label for="product_commentaire" class="inline-flex w-full gap-2 justify-between items-center rounded-full !py-0 !pl-4 !pr-0">
        <span class="mr-2">{{label}} :</span>
        <p-buttongroup>
            @if (isEditMode) {
                <p-button (click)="onSaveComment()" icon="pi pi-save" [rounded]="true" [text]="true" severity="success" [disabled]="isSendingInputData" />
                <p-button (click)="onInputClose()" icon="pi pi-times-circle" [rounded]="true" [text]="true" severity="danger" />  
            }
            @else {
                <p-button (click)="onToggleMode()" icon="pi pi-pencil" [rounded]="true" [text]="true" severity="info" [loading]="isSendingInputData" [disabled]="isSendingInputData"/>
            }
        </p-buttongroup>
    </label>
    <div class="px-4 pb-3 w-full">
        @if (isEditMode) {
            <textarea id="product_commentaire" name="product_commentaire" rows="5" fluid pTextarea [(ngModel)]="value" (keyup.escape)="onInputClose()" [pAutoFocus]="true" [autoResize]="true"></textarea>
        }
        @else {
            <div class="font-medium text-base text-md" [innerHTML]="value | nl2br"></div>
        }
    </div>
</div>